module.exports = __webpack_public_path__ + "img/orange_085.815fdaa1.png";